// web : touch
export default window?.eto_config?.version || "web";